import { Checkbox, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { Protect } from 'app/components';
import { useLocalStorage } from 'app/services';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/**
 * Универсальное меню для управления видимостью колонок
 */
const ColumnViewMenu = function (props) {
    const dispatch = useDispatch();
    const { open, onClose, anchorEl, columns, checkedItemsSelector, addItemAction, deleteItemAction, storageKey, skipFirstColumn = true, } = props;
    const checkedItems = useSelector(checkedItemsSelector);
    const [, setCheckedStorageItems] = useLocalStorage(storageKey, []);
    const handleClickItem = (value) => {
        const action = checkedItems.indexOf(value) !== -1 ? deleteItemAction(value) : addItemAction(value);
        dispatch(action);
    };
    useEffect(() => {
        setCheckedStorageItems(checkedItems);
    }, [checkedItems, setCheckedStorageItems]);
    const displayColumns = skipFirstColumn ? columns.slice(1) : columns;
    return (React.createElement(Menu, { open: open, onClose: onClose, anchorEl: anchorEl, PaperProps: {
            sx: (theme) => ({
                marginTop: theme.spacing(1.5),
                '&:before': {
                    right: '10px',
                },
            }),
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, sx: (theme) => ({
            '.MuiListItemIcon-root': {
                minWidth: '26px!important',
            },
            '.MuiCheckbox-root': {
                padding: theme.spacing(0),
                marginLeft: theme.spacing(0),
                svg: {
                    fontSize: '18px',
                },
            },
        }) }, displayColumns.map((column) => (React.createElement(Protect, { key: column.name, permissions: column.permissions, renderPermitted: () => (React.createElement(MenuItem, { disableRipple: true, onClick: () => handleClickItem(column.name) },
            React.createElement(ListItemIcon, null,
                React.createElement(Checkbox, { size: 'small', edge: 'start', tabIndex: -1, disableRipple: true, checked: checkedItems.indexOf(column.name) !== -1 })),
            React.createElement(ListItemText, null, column.label))), renderForbidden: () => React.createElement(React.Fragment, null) })))));
};
export default ColumnViewMenu;
